export const constants = {
	selector: {
		target: 'data-select',
		label: 'data-select-label',
		render: 'data-select-render',
		dynamicOptionAttribute: 'data-select-dynamic-option',
	},
	attribute: {
		freeSolo: 'data-select-freesolo',
		allOption: 'data-select-alloption', // Both allOption and noOption have to be filled in together
		noOption: 'data-select-nooption', // Both allOption and noOption have to be filled in together
		noneOption: 'data-select-noneoption',
		placeholder: 'data-select-placeholder',
	},
}
